module.exports = __webpack_public_path__ + "static/media/logoweb.292f7454.png";